import { TemplateRef } from '@angular/core';

export enum OperationToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export interface OperationToast {
  id: string;
  textOrTpl: string | TemplateRef<unknown>;
  type?: OperationToastType;
  delay?: number;
  title?: string;
  dismissible?: boolean;
  description?: string;
  isExpanded?: boolean;
  isProcessing?: boolean;
  customTemplate?: TemplateRef<unknown>;
  customTemplateContext?: unknown;
  actions?: OperationToastAction[];
  onClose?: () => void;
}

export interface OperationToastAction {
  label: string;
  icon?: string;
  handler: () => void;
  buttonClass?: string;
}
